import React, {useState} from 'react'
import Swiper from 'react-id-swiper'
import 'swiper/css/swiper.css'

const ImageSwiper = (props) => {

    const [params] = useState({
        effect: 'fade',
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
        },
        loop: true
    })

    const images = props.images

    // 画像が複数枚無い場合はページネーション非表示
    if (images.length < 2) {
        params.pagination = {}
    }

    return (
        <Swiper {...params} >
            {images.map(image => (
                <div key={image.id}>
                    <img src={image.path} alt='商品画像'/>
                </div>
            ))}
        </Swiper>
    )
}
export default ImageSwiper